/**
 * Bold text style for react-native-render-html tag styles (strong, b, th).
 * With Sofia Pro loaded, bold must be its own family because Android ignores
 * fontWeight on custom fonts; otherwise the system font takes the weight.
 */
export const getHtmlBoldStyle = ({ areBrandFontsLoaded, fontFamily }) => (
	areBrandFontsLoaded ? { fontFamily: fontFamily('700') } : { fontWeight: '700' }
);
